import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getHappyCustomer = async (id) => {
  try {
    return await getData(`/without-login/home/get-happy-customer`);
  } catch (error) {
    console.log(error);
  }
};

export const getWhyRide = async (id) => {
  try {
    return await getData(`/without-login/home/get-why-ride`);
  } catch (error) {
    console.log(error);
  }
};

export const getKeyServices = async (id) => {
  try {
    return await getData(`/without-login/home/get-key-services`);
  } catch (error) {
    console.log(error);
  }
};

export const getattachYourTaxi = async (id) => {
  try {
    return await getData(`/without-login/home/attach-your-taxi`);
  } catch (error) {
    console.log(error);
  }
};

export const AttachTaxiPost = async (data) => {
  try {
    const res = await postData(`/attach-your-taxi/save`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getdataCategory = async (data) => {
  try {
    const res = await getData(`/without-login/allcategories`);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getDataBanner = async (data) => {
  try {
    const res = await getData(`/without-login/all-banner`);

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const getCabCategory = async (data) => {
  try {
    const res = await getData(`/without-login/all-cab-category`);

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const getallTestimonial = async ({ page = "", per_page = "" }) => {
  try {
    const res = await getData(`/without-login/all-testimonial?page=${page || ""}&per_page=${per_page || ""}`);

    return res;
  } catch (error) {
    console.log(error);
  }
};

